import { preventScroll, restoreScroll } from "../utils/prevent-scroll";

export function toggleFilterMenu() {
  let filterOpen = false;
  const menu = document.querySelector(".FilterMenu");
  menu.classList.add("transition-transform");
  filterOpen = menu.classList.toggle("translate-y-0");

  if (filterOpen) {
    preventScroll(0);
  } else {
    restoreScroll(0);
  }
}

export function uncheckAllCheckboxes() {
  const checkboxes = document.querySelectorAll(".dropdown-checkbox");

  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
  });
}
